var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.12512C8.75 6.81262 8.4375 3.35325 8.4375 3.25012L8.5 5.12512ZM8.5 5.12512H12H15.5625V3.25012C15.375 4.93762 15.5625 3.35325 15.5625 3.25012V5.12512H17.25V3.25012C17.25 2.42278 16.5773 1.75012 15.75 1.75012H8.25C7.42266 1.75012 6.75 2.42278 6.75 3.25012V5.12512H8.4375H8.5ZM20.25 5.12512H3.75C3.33516 5.12512 3 5.46028 3 5.87512V6.62512C3 6.72825 3.08437 6.81262 3.1875 6.81262H4.60312L5.18203 19.0704C5.21953 19.8697 5.88047 20.5001 6.67969 20.5001H17.3203C18.1219 20.5001 18.7805 19.872 18.818 19.0704L19.3969 6.81262H20.8125C20.9156 6.81262 21 6.72825 21 6.62512V5.87512C21 5.46028 20.6648 5.12512 20.25 5.12512Z",
    fill: "#B5BDCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGrey);
export default __webpack_public_path__ + "static/media/delete-grey.5f5b9aca28d7c6a735134be2d01ce8e0.svg";
export { ForwardRef as ReactComponent };